import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Bem-vindo de volta!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative overflow-hidden bg-black">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,hsl(42_60%_20%/0.45),transparent_50%),radial-gradient(circle_at_80%_75%,hsl(42_60%_25%/0.35),transparent_55%)]" />
        <div className="relative h-full w-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-sm bg-black ring-1 ring-[hsl(42_30%_30%)] overflow-hidden flex items-center justify-center">
              <img src="/brand/marupiara-logo.png" alt="Marupiara" className="w-full h-full object-contain" />
            </div>
            <span className="font-display text-xl tracking-tight">Marupiara <span className="text-[hsl(var(--gold-soft))]">Editoração</span></span>
          </div>
          <div className="flex-1 flex items-center justify-center">
            <img src="/brand/marupiara-logo.png" alt="Marupiara" className="w-64 h-64 object-contain opacity-95" />
          </div>
          <div className="max-w-md">
            <h1 className="font-display text-4xl lg:text-5xl leading-tight tracking-tight">
              <span className="text-[hsl(var(--gold-soft))]">Marupiara</span>: onde cada obra encontra seu lugar no mundo.
            </h1>
            <p className="mt-4 text-white/70 text-sm leading-relaxed">
              Editoração, vendas, contratos e gestão financeira — tudo num único sistema sob medida para a Marupiara Editoração.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-sm bg-black overflow-hidden flex items-center justify-center">
              <img src="/brand/marupiara-logo.png" alt="Marupiara" className="w-full h-full object-contain" />
            </div>
            <span className="font-display text-lg">Marupiara</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-bold mb-3">Acesso restrito</p>
          <h2 className="font-display text-3xl tracking-tight mb-2">Entrar no sistema</h2>
          <p className="text-sm text-muted-foreground mb-8">
            Use suas credenciais para acessar o ERP da Marupiara Editoração.
          </p>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <Label className="text-xs font-semibold">Usuário</Label>
              <Input data-testid="login-username" type="text" value={username}
                     onChange={(e) => setUsername(e.target.value)} className="mt-1" required autoComplete="username" autoFocus />
            </div>
            <div>
              <Label className="text-xs font-semibold">Senha</Label>
              <Input data-testid="login-password" type="password" value={password}
                     onChange={(e) => setPassword(e.target.value)} className="mt-1" required autoComplete="current-password" />
            </div>
            <Button data-testid="login-submit" type="submit" className="w-full" disabled={loading}>
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>

          <div className="mt-8 p-3 border border-border rounded-sm bg-muted/40">
            <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground mb-1">Sistema Marupiara Editoração</p>
            <p className="text-xs text-muted-foreground">Acesso restrito a usuários autorizados. Em caso de dúvida, contate a administração.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
